import { formatData } from '../helpers/dealerProfile'
import { request } from './_request';

export const getData = (anio, mes,type,vsMorD) => {


    return (dispatch, getState) => {
        const user = JSON.parse(localStorage.getItem('@@auth_user'));
        dispatch({
            type: 'SEARCH_DATA',
        })

        request
            .get('/resumen_gerencial/data', { params: { year: anio, month: mes }, headers: { 'Authorization': `Bearer ${user.token}` } })
            .then((response) => {
                let data = response.data;

                formatData(data.result,anio,mes,type,vsMorD).then((result)=>{
                    console.log(result)
                      dispatch({ type: 'READY_DATA_RESUMEN_GERENCIAL',
                            payload:{data:result,rawData:data.result}});
                 })
               console.log(response.data)
            })
    }
}

export const getChart = (type,idIndicator,idBrand,year) => {
	
	
	return (dispatch,getState) => {
		
		dispatch({ type: 'LOADING_CHART_RESUMEN_GERENCIAL',payload:{type:type,loading:true}});
	   
	    const user = JSON.parse(localStorage.getItem('@@auth_user'));
	    
		request
			.get('/resumen_gerencial/chart',{params:{year:year,idIndicator:idIndicator,idBrand:idBrand},headers: {'Authorization':`Bearer ${user.token}`}})
			.then((response) => {
				let data = response.data;

				if (!data.error) {

				    dispatch({ type: 'READY_DATA_CHART_RESUMEN_GERENCIAL',
				   			payload:{data:data.result,type:type}});

				} else {

					if (data.code==-1)
					{
						localStorage.removeItem('@@auth_user');
						dispatch({ type: 'ERROR_TOKEN_MAIN',
							payload:{message:data.message,code:-1}});
						dispatch({ type: 'LOADING_CHART_RESUMEN_GERENCIAL',payload:{type:type,loading:false}});
					}else
					{
						dispatch({ type: 'ERROR_RESUMEN_GERENCIAL',
				   			payload:data.message});
						dispatch({ type: 'LOADING_CHART_RESUMEN_GERENCIAL',payload:{type:type,loading:false}});
					}

				}
			})
			.catch((e) =>
			{
				dispatch({ type: 'ERROR_RESUMEN_GERENCIAL',
				   	payload:e.message});
				dispatch({ type: 'LOADING_CHART_RESUMEN_GERENCIAL',payload:{type:type,loading:false}});
			});
		}
};

export const change_filter = (anio, mes) => {

    return (dispatch, getState) => {
        dispatch({
            type: 'CHANGE_FILTER',
            payload: { anio: anio, mes: mes }
        })
    }
}


export const changeSelectStatusChart = (type,select,value) =>
{

    return (dispatch,getState) => {
	    let selectStatusChart = getState().dealerProfile.selectStatusChart
	    if (select==="idBrand" || select==="idIndicator" || select==="year")
	    {
	    	dispatch({ type: 'READY_DATA_CHART_RESUMEN_GERENCIAL',
				   			payload:{data:null,type:type}});
	    }
	    dispatch({type:'CHANGE_SELECT_CHART_RESUMEN_GERENCIAL',payload:{type:type,select:select,value:value}})}

}


export const getSelect = (year,month,type,vsMorD) => {
	
	
	return (dispatch,getState) => {
		
		dispatch({ type: 'LOADING_RESUMEN_GERENCIAL',payload:true});
	   
	    const user = JSON.parse(localStorage.getItem('@@auth_user'));
	    
		request
			.get('/resumen_gerencial/select',{headers: {'Authorization':`Bearer ${user.token}`}})
			.then((response) => {
				let data = response.data;

				if (!data.error) {

				    dispatch({ type: 'READY_SELECT_RESUMEN_GERENCIAL',
				   			payload:data.result});
				    			   

				} else {

					if (data.code==-1)
					{
						localStorage.removeItem('@@auth_user');
						dispatch({ type: 'ERROR_TOKEN_MAIN',
							payload:{message:data.message,code:-1}});
						dispatch({ type: 'ERROR_RESUMEN_GERENCIAL',
							payload:data.message});
					}else
					{
						dispatch({ type: 'ERROR_RESUMEN_GERENCIAL',
				   			payload:data.message});
					}

				}
			})
			.catch((e) =>
			{
				dispatch({ type: 'ERROR_RESUMEN_GERENCIAL',
				   	payload:e.message});
			});
		}
};


export const changeTypeData = (type) => {
	
	return (dispatch,getState) => {
		     
		    dispatch({ type: 'CHANGE_TYPE_DATA_RESUMEN_GERENCIAL',
				payload:type});
		     
			 
		}
};

export const changeType = (type) => {
	
	return (dispatch,getState) => {
		     dispatch({ type: 'LOADING_RESUMEN_GERENCIAL',payload:true});
		     let rawData = getState().dealerProfile.rawData
		     let year = getState().dealerProfile.year
		     let month = getState().dealerProfile.month
		     let vsMorD = getState().dealerProfile.vsMorD
		     formatData(rawData,year,month,type,vsMorD).then((result)=>{
		     	dispatch({ type: 'CHANGE_TYPE_RESUMEN_GERENCIAL',
				   	payload:{data:result,type:type,vsMorD:vsMorD}});
		     })
			 
		}
};

export const changeVsMorD = (vsMorD) => {
	
	return (dispatch,getState) => {
		     dispatch({ type: 'LOADING_RESUMEN_GERENCIAL',payload:true});
		     let rawData = getState().dealerProfile.rawData
		     let year = getState().dealerProfile.year
		     let month = getState().dealerProfile.month
		     let type = getState().dealerProfile.type
		     formatData(rawData,year,month,type,vsMorD).then((result)=>{
		     	dispatch({ type: 'CHANGE_TYPE_RESUMEN_GERENCIAL',
				   	payload:{data:result,type:type,vsMorD:vsMorD}});
		     })
		     
		}
};